<template>
  <div id="app">
    <header>
      <img class="header-logo" src="@/assets/images/axa_logo.svg" alt="logo" />
      <h2 class="title" v-if="currentPage !== 'start'">{{ serviceTexts.intro }}</h2>
      <LanguageComponent :language="language" :onLanguageChange="changeLanguage"/>
    </header>

    <div v-if="currentPage === 'start'" class="start-page">
      <h1 class="title">{{ serviceTexts.intro }}</h1>
      <h4 class="subtitle">{{ serviceTexts.subtitle }}</h4>
      <div class="button-container">
        <button @click="startQuiz">{{ serviceTexts.start }}</button>
      </div>
      <footer>

      </footer>
    </div>

    <QuizComponent
        v-if="currentPage === 'quiz'"
        :language="language"
        :onComplete="completeQuiz"
    />

    <ResultComponent
        v-if="currentPage === 'result'"
        :language="language"
        :score="score"
        :onLanguageChange="changeLanguage"
    />
  </div>
</template>

<script>
import LanguageComponent from "./components/LanguageComponent.vue";
import QuizComponent from "./components/QuizComponent.vue";
import ResultComponent from "./components/ResultComponent.vue";
import serviceData from '@/assets/service.json';

export default {
  components: {
    LanguageComponent,
    QuizComponent,
    ResultComponent,
  },
  data() {
    return {
      language: "de",
      currentPage: 'start',
      score: 0,
      serviceTexts: {
        start: 'Start',
      },
    };
  },
  watch: {
    language(newLang) {
      this.loadContent(newLang);
    },
  },
  created() {
    this.loadContent(this.language);
  },
  methods: {
    changeLanguage(newLanguage) {
      this.language = newLanguage;
    },
    loadContent(language) {
      if (serviceData[language]) {
        this.serviceTexts = serviceData[language];
      }
    },
    startQuiz() {
      this.currentPage = "quiz";
    },
    completeQuiz(score) {
      this.score = score;
      this.currentPage = "result";
    },
  },
};
</script>
